export const formatPhone = (phone) => {
  if (!phone) {
    return null;
  }
  const num = phone.replace(/[^\d]/g, '');
  const c = num.match(/(\d{3})?(\d{3})?(\d{4})?(\d*)/i).slice(1).filter(v => v).slice(0, 3);
  const stringPhone = c[0] ? `(${ c[0] }${c[1] ? (`${') '}${ c[1] }${c[2] ? `-${ c[2]}` : ''}`) : ''}` : '';
  return stringPhone;
};

export const formatNumberOnly = (val, num) => {
  const newVal = val.replace(/[^\d]/g, '');
  if (num && newVal.length > num) {
    return newVal.slice(0, num);
  }
  return newVal;
};

export const formatCanadaZip = (val) => {
  const newVal = val.replace(/[^0-9a-zA-Z]/g, '');
  if (newVal.length > 6) {
    return newVal.slice(0, 6);
  }
  return newVal;
};

export const nonZero = (val) => {
  const newVal = val.replace(/[^\d]/g, '');
  if (val && newVal > 0) {
    return newVal;
  }
  return newVal;
};



// WEBPACK FOOTER //
// ./src/misc/formatPhone.js